import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'
import {
  Chart,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  DoughnutController,
  LineController,
  PieController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'

Chart.register(
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  DoughnutController,
  LineController,
  PieController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
)

export default class ChartController extends Controller {
  static values = {
    type: { type: String, default: 'bar' },
    labels: Array,
    datasets: Array,
    options: { type: Object, default: {} }
  }

  connect () {
    const isDark = document.documentElement.classList.contains('dark')
    const gridColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'
    const textColor = isDark ? '#a1a1aa' : '#71717a'

    const defaults = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: { color: textColor, boxWidth: 12, padding: 16 }
        },
        tooltip: {
          backgroundColor: isDark ? '#27272a' : '#fff',
          titleColor: isDark ? '#f4f4f5' : '#18181b',
          bodyColor: textColor,
          borderColor: isDark ? '#3f3f46' : '#e4e4e7',
          borderWidth: 1,
          padding: 10,
          cornerRadius: 8
        }
      },
      scales: {
        x: {
          ticks: { color: textColor },
          grid: { color: gridColor }
        },
        y: {
          ticks: { color: textColor },
          grid: { color: gridColor },
          beginAtZero: true
        }
      }
    }

    const mergedOptions = this.#deepMerge(defaults, this.optionsValue)

    this.chart = new Chart(this.element, {
      type: this.typeValue,
      data: {
        labels: this.labelsValue,
        datasets: this.datasetsValue
      },
      options: mergedOptions
    })
  }

  disconnect () {
    this.chart?.destroy()
  }

  #deepMerge (target, source) {
    const out = { ...target }
    for (const key of Object.keys(source)) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        out[key] = this.#deepMerge(target[key] || {}, source[key])
      } else {
        out[key] = source[key]
      }
    }
    return out
  }
}

stimulus.register('chart', ChartController)
